import {
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  Input,
  SimpleChanges,
  EventEmitter,
  Output
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import {
  NgxFileDropEntry,
  FileSystemFileEntry,
  FileSystemDirectoryEntry,
} from 'ngx-file-drop';
import {
  DropDownOptions,
  ExtendedAttachmentType,
  ExtendedKeycloakUser,
  FileInformation,
  MyPurchaseForm,
  UserInformation,
} from 'src/app/shared/models/app-models';
import { FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil, lastValueFrom, take, concatMap, filter, Observable } from 'rxjs';
import { Attachment, AttachmentTypeIdEnum, ContractExecutive } from 'src/app/shared/models/database-models/';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { InputDialogComponent } from 'src/app/shared/components/input-dialog/input-dialog.component';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { environment } from 'src/environments/environment';
import { StoreDropdowns } from 'src/app/shared/models/app-models/StoreDropdowns.model';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { FileStore } from 'src/app/core/store/attachment.store';
import { AttachmentTableInformation } from 'src/app/shared/models/app-models/FileInformation.model';
import { addAttachment, deleteAttachment, getAllAttachment, updateAttachment } from '../../../core/store/attachment.action';
import _, { isEmpty } from 'lodash';
import { BannerService, BannerType } from 'src/app/shared/services/banner.service';
import { PurchaseType, PurchaseTypeMap } from 'src/app/shared/models/app-models/Approving.model';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { vendorDoc } from 'src/app/core/services/permissions/AppAbility';
import { AttachmentTaggingComponent, AttachmentTaggingResult, AttachmentTaggingType } from './attachment-tagging/attachment-tagging.component';
import { DocumentMainStatus, DocumentStatusToRemoveDIRP, DocumentSubStatus, DocumentSubStatusToRemoveDIRP, DocumentSubStatusToStrikeThroughDIRP } from 'src/app/shared/models/database-models/DocumentStatus.model';
import { DropdownComponent } from 'src/app/shared/components';
import { RfqOutputService } from '../rfq-output/rfq-output.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
export interface AttachmentData {
  attachment: Attachment[];
}

@Component({
  selector: 'app-attachment',
  templateUrl: './attachment.component.html',
  styleUrls: ['./attachment.component.scss'],
  providers: [
    {
      provide: DatePipe,
    },
    FileStore,
  ],
})
export class AttachmentComponent implements OnInit, OnDestroy {
  @ViewChild('attachmentPg') paginator!: MatPaginator;
  @ViewChild('table') table: MatTable<FileUpload> | undefined;
  fileUploadErrorMsg: string =
    'Pleasae correct the error in following tab : <br> <b>Attachments<b> <br><ul><li>Please ensure that there are no blacklisted file types uploaded.</li></ul>';
  fileNameErrorMsg: string =
    'The following special characters are not allowed for filename: “~ # % * , { }  : < > ? / + | & ” . ".';
  showErrorMessage: boolean = false;
  errorMsg: string = '';
  filePageSize: number = 5;
  fileFormStore: FileInformation[] = [];
  fileCurrentPage = 0;
  files: NgxFileDropEntry[] = [];
  fileUploadList: FileInformation[] = [];
  fileUploadDS = new MatTableDataSource<FileInformation>([]);
  files$ = this.fileStore.files$;
  @Input() isReadOnly: boolean = false;
  @Input() isLocked: boolean = true
  @Output() attachmentLoaded = new EventEmitter<any>()
  kcUserList: ExtendedKeycloakUser[] = [];
  columns = [
    {
      columnDef: 'FileName',
      header: 'File Name',
      cell: (element: FileInformation) => `${element.attachment.FileName}`,
    },
    {
      columnDef: 'CreatedBy',
      header: 'Uploaded by',
      cell: (element: FileInformation) =>
        `${this.kcUserList.find(
          (user) => user.username == element.attachment.CreatedBy
        )?.value ?? element.attachment.CreatedBy
        }`,
    },
    {
      columnDef: 'Purpose',
      header: 'Purpose',
      cell: (element: FileInformation) => `${element.tableInformation.Purpose}`,
    },
    {
      columnDef: 'ItemsTagged',
      header: 'Item Tagged',
      cell: (element: FileInformation) =>
        `${element.tableInformation.TaggedItems ? element.tableInformation.TaggedItems : '-'}`,
    },
    {
      columnDef: 'RFQVendorTagged',
      header: 'RFQ-Vendor Tagged',
      cell: (element: FileInformation) => {
        const RFQNumber: string | undefined = element.tableInformation.RFQNumber;
        const RFQVendorTagged: string | undefined = element.tableInformation.RFQVendorTagged;

        if((isEmpty(RFQNumber) || RFQNumber == "-") && (isEmpty(RFQVendorTagged) || RFQVendorTagged == "-")) {
          return "-";
        }

        return [RFQNumber, RFQVendorTagged].filter((txt) => !isEmpty(txt)).join(" - ");
      }
    },
    {
      columnDef: 'FileSize',
      header: 'File Size',
      cell: (element: FileInformation) =>
        `${element.tableInformation.FileSize} MB`,
    },
    {
      columnDef: 'DateUploaded',
      header: 'Date Uploaded',
      cell: (element: FileInformation) =>
        `${element.tableInformation.DateUploaded}`,
    },
    {
      columnDef: 'Action',
      header: 'Action',
      cell: (element: FileInformation) => `${element.tableInformation.Action}`,
    },
  ];
  displayedColumns = this.columns.map((c) => c.columnDef);
  displayColumns: string[] = [];
  purposeControls: FormControl[] = [];
  destroy$: Subject<boolean> = new Subject<boolean>();
  dialogChoice: boolean = false;
  existingFile?: FileInformation;
  addFileExistCount: number = 0;
  wasAttachmentsUpdated: boolean = false
  wasAttachmentsAdded: boolean = false
  purposeValue: number = 0;
  selectedPurpose: string[] = [];
  //dropdown and file ext values
  pendingQuotationOptions: DropDownOptions[] = [];
  fileExtList: string[] = [];
  formattedExtList: string[] = [];
  imgSrc: string = '';
  isPictureFile: boolean[] = [];
  loggedInUser!: UserInformation;
  isLoadingData: boolean = true;
  limit: number = 5;
  pageSize: number = 5;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage: number = 0;
  totalCount: number = 0;
  mpNumber: string = '';
  kcUpdateAttachmentRole: boolean = false
  isCE: boolean = false;
  isRFQ: boolean = false;
  purchaseTypeId: number = 0;
  isPartOfCE: boolean = false;
  dp: any
  originalAttachmentTypeList: AttachmentTypeWholeList = {
    RO: [],
    CE: [],
  };
  attachmentTypeList: AttachmentTypeWholeList = {
    RO: [],
    CE: [],
  };
  CE: string | null | undefined = null;
  RO: string | null | undefined = null;
  CreatedBy: string | null | undefined = null;
  documentStatus: any = {
    mainStatus: 1,
    subStatus: 1,
  };
  readonly permissionData$: Observable<any>
  originalROAttachmentType: ExtendedAttachmentType[] = [];
  purchaseTypeMap = PurchaseTypeMap;
  form!: MyPurchaseForm;
  isDIRP:boolean | null  = false;
  isRestrictedITProductPolicy:boolean | null  = false;
  isRFQNotRequired: boolean = false;
  isButtonDisplay : boolean = true;
  constructor(
    private cdr: ChangeDetectorRef,
    private permissionsService: PermissionsService,
    public materialDialog: MatDialog,
    private store: Store<{
      dp: StoreDropdowns;
      user: UserInformation;
      form: MyPurchaseForm;
      attachment: FileInformation[];
    }>,
    private backendService: BackendApiService,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<InputDialogComponent>,
    private dialoginfo: MatDialogRef<DialogComponent>,
    private readonly fileStore: FileStore,
    private bannerService: BannerService,
    private rfqOutputService: RfqOutputService,
    private _snackBar: MatSnackBar,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer
  ) {
    this.iconRegistry.addSvgIcon(
      'mp-cloud-update',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/material-icons/material-icon-cloud-update.svg')
    );
    this.iconRegistry.addSvgIcon(
      'mp-description',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/material-icons/material-icon-description.svg')
    );
    this.iconRegistry.addSvgIcon(
      'mp-straighten',
      this.sanitizer.bypassSecurityTrustResourceUrl('assets/material-icons/material-icon-straighten.svg')
    );
    this.permissionData$ = this.permissionsService.getService().pipe(takeUntil(this.destroy$))
    this.permissionData$.subscribe((data) => {
      if (data.ability.can('update', data.formVendorDoc))
        this.kcUpdateAttachmentRole = data.ability.can('update', data.formVendorDoc) ? true : false
    })
    this.mpNumber = this.route.snapshot.params['id'].split(';')[0] as string;
    this.store
      .select('user')
      .pipe(takeUntil(this.destroy$))
      .subscribe((user) => {
        this.loggedInUser = user;
        this.dropdownValuesAllocator();
      });
    this.store
      .select('attachment')
      .pipe(takeUntil(this.destroy$))
      .subscribe((files: FileInformation[]) => {
        this.fileFormStore = files;
      });
    this.store
      .select('form')
      .pipe(takeUntil(this.destroy$))
      .subscribe(async (form: MyPurchaseForm) => {
        this.CE = form.CE;
        this.RO = form.generalForm.RO.id;
        this.CreatedBy = form.createdBy;
        this.documentStatus = {
          mainStatus: form.documentStatusId,
          subStatus: form.documentSubStatusId,
        };
        //TODO - check with Muthu
        if (this.RO == this.loggedInUser.userName && (form.documentStatusId == 9 && (form.documentSubStatusId == 25 || form.documentSubStatusId == 50))) {
          this.isRFQ = true;
        }
        this.isDIRP = form.generalForm.isDIRP
        this.isRestrictedITProductPolicy =
          form.PurchaseTypeId &&
          (
            [
              PurchaseType.RFQ,
              PurchaseType.TENDER,
              PurchaseType.DC,
              PurchaseType.CORPORATE_CARD,
              PurchaseType.PCPO,
              PurchaseType.PERMISSIBLE_COVERING
            ] as string[]
          ).includes(PurchaseTypeMap[form.PurchaseTypeId]) &&
          form.ItemList.some(
            (item) =>
              item.AddItems?.MaterialSubGroupId?.RestrictedITProductPolicy &&
              item.AddItems.MaterialSubGroupId.RestrictedITProductPolicy.toLowerCase().includes(
                'cat'
              )
          )
            ? true
            : false;

        if (form.PurchaseTypeId) {
          this.purchaseTypeId = form.PurchaseTypeId
          if (this.fileUploadList.length > 0){
            this.mapFilesToTable(this.fileUploadList)
          }
          else{
            this.filterAttachmentTypeListByPurchaseId(form.PurchaseTypeId)
          }
          if (form.PurchaseTypeId === 1) {
            if (form.generalForm.reasonForNotUsingRFQ.value !== environment.optForRFQReasonCode) {
              this.isRFQNotRequired = true;
            } else {
              this.isRFQNotRequired = false;
            }
          }
        }

        const oldForm = _.cloneDeep(this.form);
        this.form = form;

        // Load data after form documentStatus has been fetched / changed for saved documents
        if (
          this.mpNumber &&
          form &&
          oldForm &&
          (form.documentStatusId !== oldForm.documentStatusId ||
            form.documentSubStatusId !== oldForm.documentSubStatusId)
        ) {
          await this.loadDataBasedOnPageAndLimit();
        }

        this.dropdownValuesAllocator();
      });
  }
  filterAttachmentTypeListByPurchaseId(purchaseTypeId: number) {
    if (this.originalAttachmentTypeList.CE.length && this.originalAttachmentTypeList.RO.length)
      this.attachmentTypeList = {
        RO: this.originalAttachmentTypeList.RO.filter((x) =>
          x.ApplicablePurchaseTypeIds.includes(purchaseTypeId)
        ), // filter this based on form purchase type id
        CE: this.originalAttachmentTypeList.CE.filter((x) =>
          x.ApplicablePurchaseTypeIds.includes(purchaseTypeId)
        ), // filter this based on form purchase type id
      };
      //todo: SX
      const uniqueIds = new Set(this.attachmentTypeList.RO.map(option => option.AttachmentTypeId));
      let filteredCE = this.attachmentTypeList.RO.concat(
            this.attachmentTypeList.CE.filter(option => !uniqueIds.has(option.AttachmentTypeId)))
    if(this.documentStatus.mainStatus == 9) {
        this.pendingQuotationOptions = filteredCE.filter(option => option.IsDuringPendingQuotations);
    }
    else {
      this.pendingQuotationOptions = filteredCE;
    }

  }
  isFileAttachmentApplicableForThisDocument(isRO: boolean, purchaseTypeId: number, attachmentType: ExtendedAttachmentType, documentStatusId: number, documentSubStatusId: number) {
    console.log('isFileAttachmentApplicableForThisDocument', purchaseTypeId, attachmentType, documentStatusId, documentSubStatusId)
    if (isRO && PurchaseTypeMap[purchaseTypeId] == PurchaseType.PCPO && documentSubStatusId == DocumentSubStatus.Aor_Rejected && documentStatusId == DocumentMainStatus.Rejected && attachmentType.Name == 'Quotation') return false
    if (isRO && PurchaseTypeMap[purchaseTypeId] == PurchaseType.PCPO && documentSubStatusId == DocumentSubStatus.Aor_Draft && documentStatusId == DocumentMainStatus.Draft && attachmentType.Name == 'Quotation') return false
    return true
  }
  filterFileAttachmentOptions(pendingQuotationOptions: DropDownOptions[], fileUploadList: FileInformation[]) {
    let newfileUploadList: FileInformation[] = []
    fileUploadList.forEach(file => {
      let editingRights = this.haveEditingRightsDuringPendingQuotation(file)
      let purposeDropdowns: DropDownOptions[] = editingRights ? pendingQuotationOptions : this.returnFileAttachmentType(file)
      console.log('filterFileAttachmentOptions', pendingQuotationOptions, editingRights)

      let newAttachment = structuredClone(file.attachment)
      // newAttachment.AttachmentTypeId = !file.attachment.AttachmentTypeId && purposeDropdowns.find(x => x.id == AttachmentTypeIdEnum.QUOTATION.toString()) ? AttachmentTypeIdEnum.QUOTATION : file.attachment.AttachmentTypeId
      newAttachment.AttachmentTypeId = file.attachment.AttachmentTypeId;
      newAttachment.TaggedItems = file.attachment.TaggedItems
      let buttonDisplay = true
      if (
        this.form.isRFSEnabled &&
        !this.isRFQNotRequired &&
        !newAttachment.Strikethrough &&
        !newAttachment.isDeleted &&
        Number(newAttachment.AttachmentTypeId.toString()) === AttachmentTypeIdEnum.DOCUMENT_TO_VENDOR
      ) {
        buttonDisplay = false
      } 
  
      if (
        ((this.form.documentStatusId === DocumentMainStatus.Pending_Quotation &&
          this.form.documentSubStatusId === DocumentSubStatus.Rfq_Sent) ||
          this.form.documentStatusId === DocumentMainStatus.Completed) &&
        !newAttachment.Strikethrough &&
        !newAttachment.isDeleted &&
        Number(newAttachment.AttachmentTypeId.toString()) === AttachmentTypeIdEnum.QUOTATION
      ) {
        buttonDisplay = false
      }
      let newFile = {
        ...file,
        attachment: newAttachment,
        //selectedPurpose: !file.attachment.AttachmentTypeId && editingRights && purposeDropdowns.find(x => x.id == AttachmentTypeIdEnum.QUOTATION.toString()) ? AttachmentTypeIdEnum.QUOTATION.toString() : file.attachment.AttachmentTypeId.toString(),
        selectedPurpose: file.attachment.AttachmentTypeId.toString(),
        selectedPurposeDropdowns: purposeDropdowns,
        buttonDisplay: buttonDisplay
      }
      newfileUploadList.push(newFile)
    });
    console.log('filterFileAttachmentOptions', newfileUploadList)
    return newfileUploadList
  }
  populateDropdowns(dp: StoreDropdowns) {
    this.kcUserList = dp.UserList as ExtendedKeycloakUser[];
    this.originalAttachmentTypeList = {
      RO: dp.ROAttachmentType as ExtendedAttachmentType[],
      CE: dp.CEAttachmentType as ExtendedAttachmentType[],
    };
    this.dropdownValuesAllocator();
    this.fileExtList = dp.AttachmentExtensions.map((ext) => {
      return ext.ExtensionName;
    });
    this.formattedExtList = this.fileExtList.map((ext) => {
      return '.' + ext;
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes['isReadOnly'] && changes['isReadOnly'].currentValue) {
      this.mapFilesToTable(this.fileFormStore)
    }
  }
  async ngOnInit(): Promise<void> {
    var dp$ = this.store
      .select('dp')
      .pipe(filter(x => { return x.AttachmentExtensions.length > 0 }), take(1)).pipe(concatMap((dp: StoreDropdowns) => {
        if (!this.dp) {
          this.dp = dp
          this.populateDropdowns(dp)
        }
        return this.store
          .select('attachment')
          .pipe(takeUntil(this.destroy$))
      }))
      .subscribe((files: FileInformation[]) => {
        this.mapFilesToTable(files)
      });

      if (!this.mpNumber) {
        await this.loadDataBasedOnPageAndLimit();
      }

    this.isPartOfCE = await this.checkIfUserIsCE();
  }
  getOptionStyle(item: any) {
    const restrictedITItems = this.form.ItemList.filter((item) => {
      return item.AddItems?.MaterialSubGroupId?.RestrictedITProductPolicy?.toLowerCase().includes(
        'cat'
      );
    });
    if (
      item.AttachmentTypeId === AttachmentTypeIdEnum.DIRP_APPROVAL &&
      (DocumentStatusToRemoveDIRP.includes(this.form.documentStatusId) ||
        (this.form.documentSubStatusId &&
          DocumentSubStatusToRemoveDIRP.includes(
            this.form.documentSubStatusId
          )))
    ) {
      // TODO: remove this 'if' block when DIRP is fully deprecated
      return 'hidden-option';
    } else if (
      (item.IsDIRP && this.isDIRP === false) ||
      (item.IsRestrictedITProductPolicy &&
        this.isRestrictedITProductPolicy === false) ||
      (this.isRestrictedITProductPolicy &&
        item.AttachmentTypeId ===
          AttachmentTypeIdEnum.RESTRICTED_IT_PRODUCT_SD &&
        restrictedITItems.some(
          (item) =>
            item.AddItems?.MaterialSubGroupId?.RestrictedITProductPolicy?.toLowerCase() ===
            'cat2'
        )) ||
      (this.isRestrictedITProductPolicy &&
        item.AttachmentTypeId ===
          AttachmentTypeIdEnum.RESTRICTED_IT_PRODUCT_SD_CDO &&
        restrictedITItems.every(
          (item) =>
            item.AddItems?.MaterialSubGroupId?.RestrictedITProductPolicy?.toLowerCase() ===
            'cat1'
        ))
    ) {
      return 'disabled-option';
    } else if 
    (this.isRFQNotRequired &&
      item.AttachmentTypeId === AttachmentTypeIdEnum.DOCUMENT_TO_VENDOR
    ) { 
      return 'disabled-option';
    } else if (!(
      this.form.documentStatusId ===
      DocumentMainStatus.Pending_Quotation &&
      this.form.documentSubStatusId === DocumentSubStatus.Rfq_Sent
    ) &&
    !(this.form.documentStatusId === DocumentMainStatus.Completed) &&
    item.AttachmentTypeId === AttachmentTypeIdEnum.QUOTATION && this.purchaseTypeId !== 3 && this.purchaseTypeId !== 9)  {
      return 'disabled-option';
    }
    else {
      return '';
    }
  }

  mapFilesToTable(files: FileInformation[]) {
    console.log("sx :" + this.purchaseTypeId);
    //this.fileUploadList  = files
    if (this.purchaseTypeId) {
      this.filterAttachmentTypeListByPurchaseId(this.purchaseTypeId)
      this.fileUploadList = this.filterFileAttachmentOptions(this.pendingQuotationOptions, files)
    }
    else {
      this.fileUploadList = files.map((file) => ({
        ...file,
        selectedPurpose: file.attachment.AttachmentTypeId.toString(),
        selectedPurposeDropdowns: this.returnFileAttachmentType(file),
      }));
    }
    this.fileUploadDS = new MatTableDataSource<FileInformation>(
      this.fileUploadList
    );
    this.fileUploadDS.paginator = this.paginator;
  }
  returnFileAttachmentType(file: FileInformation) {
    const isReadOnly = this.isFileAttachmentReadonly(file)
    if (!isReadOnly) {
      const isRO: boolean = file.attachment.CreatedBy == this.RO || file.attachment.CreatedBy == this.CreatedBy;
      const isCE: boolean = this.CE == this.loggedInUser.userName;
      if (this.kcUpdateAttachmentRole)
        if((isRO && isCE) || file.attachment.CreatedBy == 'SYSTEM')  
          return this.attachmentTypeList.RO.concat(this.attachmentTypeList.CE).filter(x => this.isFileAttachmentApplicableForThisDocument(isRO, this.purchaseTypeId, x, this.documentStatus.mainStatus, this.documentStatus.subStatus));
        else if(isRO)
          return this.attachmentTypeList.RO.slice().filter(x => this.isFileAttachmentApplicableForThisDocument(isRO, this.purchaseTypeId, x, this.documentStatus.mainStatus, this.documentStatus.subStatus))
        else if(isCE) 
          return this.attachmentTypeList.CE;
        else
          return this.attachmentTypeList.RO.concat(this.attachmentTypeList.CE);
      else if (isRO) {
        return this.attachmentTypeList.RO.slice().filter(x => this.isFileAttachmentApplicableForThisDocument(isRO, this.purchaseTypeId, x, this.documentStatus.mainStatus, this.documentStatus.subStatus))
      }
      else return this.attachmentTypeList.CE;
    } else return this.attachmentTypeList.RO.concat(this.attachmentTypeList.CE);
  }
  isFileAttachmentReadonly(row: FileInformation) {
    const isRO: boolean = row.attachment.CreatedBy == this.RO || row.attachment.CreatedBy == this.CreatedBy;
    const isCE: boolean = this.CE == this.loggedInUser.userName;
    if (this.documentStatus.mainStatus == 9 && (this.documentStatus.subStatus == 25 || this.documentStatus.subStatus == 50) && row.attachment.IsDuringPendingQuotations === false && isRO && !isCE) return true
    const isCEduringDocumentCEAssignedAndPendingTenderDocStage = isCE && (this.documentStatus.subStatus == 40 || this.documentStatus.subStatus == 41)
    if(this.haveEditingRightsWhenTenderDC()) return false;
    return (
      row.attachment.isDeleted || row.attachment.Strikethrough || (this.isReadOnly && !isCEduringDocumentCEAssignedAndPendingTenderDocStage)
    );
  }

  async loadDataBasedOnPageAndLimit() {
    this.isLoadingData = true;
    let fileFormDB: FileInformation[];
    let count = 0;
    try {
      let data: AttachmentData = await lastValueFrom(
        this.backendService.getDocumentAttachments(this.mpNumber)
      );
      fileFormDB = data.attachment.map((docs) => {
        let fileAttachment: Attachment = {
          ...docs,
          isDeleted: false,
        };

        if (
          docs.AttachmentTypeId === AttachmentTypeIdEnum.DIRP_APPROVAL &&
          (DocumentStatusToRemoveDIRP.includes(this.form.documentStatusId) ||
            (this.form.documentSubStatusId &&
              DocumentSubStatusToRemoveDIRP.includes(
                this.form.documentSubStatusId
              )))
        ) {
          //TODO: remove this 'if' block once DIRP has been fully deprecated
          fileAttachment.isDeleted = true;
        }

        let fileUpload: AttachmentTableInformation = {
          FileId: count,
          FileName: docs.FileName as string,
          FileLink: docs.Data as string,
          Purpose: docs.AttachmentTypeId.toString(),
          TaggedItems: docs.TaggedItems?.join(', '),
          RFQNumber: docs.RFQNumber ?? '-',
          RFQVendorTagged: docs.MPVendorDetailsId
            ? this.form.VendorsToSource.find(
                (vendor) => vendor.MPVendorDetailsId === docs.MPVendorDetailsId
              )?.Name ?? '-'
            : '-',
          RFSVendorsTagged: '-',
          FileSize: docs.FileSize as string,
          DateUploaded: docs.CreatedOn as Date,
          isPictureFile: this.isPictureFile[count],
          Action: '',
          Strikethrough: docs.Strikethrough
        };
        count += 1;
        let buttonDisplay = true
        if (
          this.form.isRFSEnabled &&
          !this.isRFQNotRequired &&
          !fileAttachment.Strikethrough &&
          !fileAttachment.isDeleted &&
          Number(fileAttachment.AttachmentTypeId.toString()) === AttachmentTypeIdEnum.DOCUMENT_TO_VENDOR
        ) {
          buttonDisplay = false
        } 
    
        if (
          ((this.form.documentStatusId === DocumentMainStatus.Pending_Quotation &&
            this.form.documentSubStatusId === DocumentSubStatus.Rfq_Sent) ||
            this.form.documentStatusId === DocumentMainStatus.Completed) &&
          !fileAttachment.Strikethrough &&
          !fileAttachment.isDeleted &&
          Number(fileAttachment.AttachmentTypeId.toString()) === AttachmentTypeIdEnum.QUOTATION
        ) {
          buttonDisplay = false
        }

        return {
          attachment: fileAttachment,
          tableInformation: fileUpload,
          fromDatabase: true,
          selectedPurpose: fileAttachment.AttachmentTypeId.toString(),
          buttonDisplay: buttonDisplay
        };
      });
      // this.fileStore.setState({ files: this.fileUploadList });
      this.store.dispatch(getAllAttachment({ files: this.intersectionFile(fileFormDB, this.fileFormStore) }));
      this.attachmentLoaded.emit(true)
      setTimeout(() => {
        this.isLoadingData = false;
      }, 100);
    } catch (e) {
      // do nothigin
    }
  }
  intersectionFile(
    fileFromDB: FileInformation[],
    fileFromStore: FileInformation[]
  ) {
    let filteredArray = [];
    if ((fileFromDB.length == 0)) {
      filteredArray = fileFromStore;
    } else if ((fileFromStore.length == 0)) {
      filteredArray = fileFromDB;
    } else {
      filteredArray = fileFromStore.filter(
        (file) => file.attachment.AttachmentId !== null || !fileFromDB.some((i) => i.attachment.AttachmentId === file.attachment.AttachmentId)
      );
    }
    return filteredArray
  }
  addFile(file: FileInformation) {
    // this.fileStore.addFile(file);
    this.store.dispatch(addAttachment({ file }));
  }
  removeFile(index: number) {
    this.wasAttachmentsUpdated = true
    // offset index
    let realIndex = this.paginator.pageIndex * this.paginator.pageSize + index;
    // this.fileStore.removeFile(realIndex);
    this.store.dispatch(deleteAttachment({ index: realIndex }));
  }

  updateFileDuringQuotation(event: DropDownOptions, file: FileInformation, index: number ) {
    let fileCopy = structuredClone(file);
    if (!file.attachment.AttachmentId) fileCopy.attachment.IsDuringPendingQuotations = true
    this.updateFile(event, fileCopy, index)
  }
  
  updateFile(event: DropDownOptions | null, prevFile: FileInformation, index: number) {
    this.wasAttachmentsUpdated = true
    const prevSelectedPurpose = prevFile.selectedPurpose;
    const file = structuredClone(prevFile);

    
    if (event) {
      // Update file obj with newly selected purpose
      file.selectedPurpose = event.id
    }

    let fileCopy = structuredClone(file);
    if (
      this.form.isRFSEnabled &&
      !this.isRFQNotRequired &&
      !file.attachment.Strikethrough &&
      !file.attachment.isDeleted &&
      Number(file.selectedPurpose) === AttachmentTypeIdEnum.DOCUMENT_TO_VENDOR
    ) {
      fileCopy.buttonDisplay = false;
      this.openAttachmentTagging(
        AttachmentTaggingType.DOCUMENT_TO_VENDOR,
        fileCopy,
        index
      );
      return;
    } 

    if (
      ((this.form.documentStatusId === DocumentMainStatus.Pending_Quotation &&
        this.form.documentSubStatusId === DocumentSubStatus.Rfq_Sent) ||
        this.form.documentStatusId === DocumentMainStatus.Completed) &&
      !file.attachment.Strikethrough &&
      !file.attachment.isDeleted &&
      Number(file.selectedPurpose) === AttachmentTypeIdEnum.QUOTATION
    ) {
      fileCopy.buttonDisplay = false;
      this.openAttachmentTagging(
        AttachmentTaggingType.QUOTATION,
        fileCopy,
        index
      );
      return;
    } 

    let realIndex = this.paginator.pageIndex * this.paginator.pageSize + index;
    // update the purpose of the file
    if (
      Array.isArray(fileCopy.attachment.TaggedItems) &&
      fileCopy.attachment.TaggedItems.length > 0
    ) {
      this.openAssociationOverwriteDialog(
        AttachmentTaggingType.DOCUMENT_TO_VENDOR,
        fileCopy,
        realIndex,
        prevSelectedPurpose
      );
      return;
    }
    if (
      fileCopy.attachment.RFQNumber ||
      fileCopy.attachment.MPVendorDetailsId
    ) {
      this.openAssociationOverwriteDialog(
        AttachmentTaggingType.QUOTATION,
        fileCopy,
        realIndex,
        prevSelectedPurpose
      );
      return;
    }

    fileCopy.attachment.IsDIRP = file.selectedPurposeDropdowns?.find(
      (x) => x.AttachmentTypeId == file.selectedPurpose
    )?.IsDIRP;
    fileCopy.attachment.IsRestrictedITProductPolicy =
      file.selectedPurposeDropdowns?.find(
        (x) => x.AttachmentTypeId == file.selectedPurpose
      )?.IsRestrictedITProductPolicy;
    if (
      (this.isDIRP === false && fileCopy.attachment.IsDIRP) ||
      (this.isRestrictedITProductPolicy === false &&
        fileCopy.attachment.IsRestrictedITProductPolicy)
    ) {
      fileCopy.attachment.AttachmentTypeId = 0;
    } else if (
      this.isRFQNotRequired &&
      Number(fileCopy.selectedPurpose) ===
        AttachmentTypeIdEnum.DOCUMENT_TO_VENDOR
    ) {
      fileCopy.attachment.AttachmentTypeId = 0;
    } else if (
      !(
        this.form.documentStatusId === DocumentMainStatus.Pending_Quotation &&
        this.form.documentSubStatusId === DocumentSubStatus.Rfq_Sent
      ) &&
      !(this.form.documentStatusId === DocumentMainStatus.Completed) &&
      Number(fileCopy.selectedPurpose) === AttachmentTypeIdEnum.QUOTATION && this.purchaseTypeId !== 3 && this.purchaseTypeId !== 9
    ) {
      fileCopy.attachment.AttachmentTypeId = 0;
      fileCopy.buttonDisplay = true;
    } else {
      fileCopy.attachment.AttachmentTypeId = Number(file.selectedPurpose ?? 0);
      fileCopy.buttonDisplay = true;
    }
    fileCopy.tableInformation.Purpose = file.selectedPurpose ?? '';
    fileCopy.buttonDisplay = true;
    this.store.dispatch(updateAttachment({ file: fileCopy, index: realIndex }));
  }

  openAssociationOverwriteDialog(type: AttachmentTaggingType, fileCopy: FileInformation, index: number, prevSelectedPurpose?: string) {
    const baseDialogOptions = {
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: undefined,
    };
    const baseDialogData = {
      headerTitle: 'Existing tagged association',
      contentMsg: `The attachment purpose you are changing has an existing item/vendor association. Your current action will overwrite this association.
      Do you want to overwrite? This action cannot be undone.`,
      btnNameOne: 'Overwrite',
      btnNameTwo: 'Cancel',
      click: () => {},
      clickTwo: () => {},
    };
    if (type === AttachmentTaggingType.DOCUMENT_TO_VENDOR) {
      this.dialoginfo = this.dialog.open(DialogComponent, {
        ...baseDialogOptions,
        data: {
          ...baseDialogData,
          click: () => {
            fileCopy.attachment.AttachmentTypeId = Number(
              fileCopy.selectedPurpose ?? 0
            );
            fileCopy.attachment.TaggedItems = undefined;
            fileCopy.tableInformation.Purpose = fileCopy.selectedPurpose!;
            fileCopy.tableInformation.TaggedItems = '-';

            this.store.dispatch(
              updateAttachment({ file: fileCopy, index: index })
            );
            this.dialoginfo.close();
          },
          clickTwo: () => {
            fileCopy.selectedPurpose = prevSelectedPurpose;
            this.store.dispatch(
              updateAttachment({ file: fileCopy, index: index })
            );
            this.dialoginfo.close();
          },
        },
      });
    } else if (type === AttachmentTaggingType.QUOTATION) {
      this.dialoginfo = this.dialog.open(DialogComponent, {
        ...baseDialogOptions,
        data: {
          ...baseDialogData,
          click: () => {
            fileCopy.attachment.AttachmentTypeId = Number(
              fileCopy.selectedPurpose ?? 0
            );
            fileCopy.attachment.RFQNumber = undefined;
            fileCopy.attachment.MPVendorDetailsId = undefined;

            fileCopy.tableInformation.Purpose = fileCopy.selectedPurpose!;
            fileCopy.tableInformation.RFQNumber = '-';
            fileCopy.tableInformation.RFQVendorTagged = '-';

            this.store.dispatch(
              updateAttachment({ file: fileCopy, index: index })
            );
            this.dialoginfo.close();
          },
          clickTwo: () => {
            fileCopy.selectedPurpose = prevSelectedPurpose;
            this.store.dispatch(
              updateAttachment({ file: fileCopy, index: index })
            );
            this.dialoginfo.close();
          },
        },
      });
    }
  }
  
  haveEditingRightsDuringPendingQuotation(row: FileInformation | undefined): boolean {
    let result;
    if (this.documentStatus.mainStatus == 9 && (this.RO == this.loggedInUser.userName || this.loggedInUser.userName == this.CreatedBy || this.documentStatus.subStatus == 25 || this.documentStatus.subStatus == 50)) {
      if (!row) result = true
      else result = row.attachment.AttachmentId == null ? true : !!row.attachment.IsDuringPendingQuotations
    }
    else result = false
    return result
  }

  //release rights when document is not in completed state
  // haveEditingRightsWhenDocNotCompleted():boolean{
  //   let result;
  //   if(this.documentStatus.mainStatus != 5){
  //     result = true
  //   }else{
  //     result = false;
  //   }
  //   return result;
  // }

  haveEditingRightsWhenTenderDC():boolean{
    let editing = false;
    //purchaseTypeId 5 - Direct Contraacting, 6 - Tender
    if((this.purchaseTypeId === 6 || this.purchaseTypeId === 5)){
      //mainStatus 6 - Rejected
      //subStatus 11 - AOR Rejected, 16 - WOC Rejected, 28 - SOW Rejected, 61 - WOC/DOTP Rejected, 36 - Pending SOW Recommendation
      if(this.RO === this.loggedInUser.userName){
      if(this.documentStatus.mainStatus === 6 && (this.documentStatus.subStatus === 11 || this.documentStatus.subStatus === 16 || this.documentStatus.subStatus === 38 || this.documentStatus.subStatus === 61) ){
          editing = true;
      }else {
        editing = false;
      }
    }
    
    // SX: not completed to allow all CE to have upload attachment rights even before CE assignment
    if(this.isPartOfCE){
      //Document Main Status - 11 - Pending PR, 5 - Completed
      //Document Sub Status - 11 - AOR Rejected, AOR Draft, Pending WOC Approval, WOC Rejected, WOC Draft, WOC+DOTP Rejected, WOC+DOTP Draft, SOW Rejected, SOW Draft
      if(this.documentStatus.mainStatus === 11 || this.documentStatus.mainStatus === 5){
        editing = false;
        //Document Sub Status - 61 = WOC-DOTP Rejected, 38 - SOW Rejected, 11 - AOR Rejected, 16 - WOC Rejected
      }else if(this.documentStatus.mainStatus === 6 && (this.documentStatus.subStatus === 61 || this.documentStatus.subStatus === 38 || this.documentStatus.subStatus === 11 || this.documentStatus.subStatus === 16)){
        editing = true;
        //Document Sub Status - 12 = AOR Draft, 17 - WOC Draft, 19 - WOC-DOTP Draft, 47 - SOW Draft 
      }else if (this.documentStatus.mainStatus === 3 && (this.documentStatus.subStatus === 12 || this.documentStatus.subStatus === 17 || this.documentStatus.subStatus === 19 || this.documentStatus.subStatus === 47)){
        editing = true;
      }else if(this.documentStatus.mainStatus === 4 && this.documentStatus.subStatus === 7){
        editing = true;
      }
    }
    }else{
      editing = false;
    }
    return editing;
  }

  async checkIfUserIsCE(){
    let CEs : ContractExecutive = await lastValueFrom(this.backendService.getContractExecutive())
    let ceList : DropDownOptions[] = CEs.ContractExecutives;
    let isCE:boolean = ceList.some((x) => x.id === this.loggedInUser.userName);
    console.log("sx checkIfUserIsCE() " + isCE);
    return isCE;
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
  async onPageChange(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.pageSize = event.pageSize;
    await this.loadDataBasedOnPageAndLimit();
  }

  openAttachmentTagging(type: AttachmentTaggingType, file: FileInformation, index: number) {
    if (type === AttachmentTaggingType.DOCUMENT_TO_VENDOR) {
      let dialogRef = this.materialDialog.open(AttachmentTaggingComponent, {
        width: '950px',
        data: {
          type: type,
          MPDocumentNumber: this.form.documentNo,
          filename: file.attachment.FileName,
          selectedPurpose: file.selectedPurposeDropdowns?.find(
            (dropdown) => dropdown.id === file.selectedPurpose
          )?.value,
          initialSelectedItemNumbers: file.attachment.TaggedItems ?? [],
        },
      });

      dialogRef.afterClosed().subscribe((result: AttachmentTaggingResult) => {
        if (result) {
          let realIndex =
            this.paginator.pageIndex * this.paginator.pageSize + index;

          let fileCopy = structuredClone(file);
          fileCopy.attachment.AttachmentTypeId = Number(file.selectedPurpose);
          fileCopy.tableInformation.Purpose = file.selectedPurpose!;

          if(result.isSubmit) {
            fileCopy.attachment.TaggedItems = result.form.selectedItemNumbers;
            fileCopy.tableInformation.TaggedItems =
            result.form.selectedItemNumbers.join(', ');
          }
          this.store.dispatch(
            updateAttachment({ file: fileCopy, index: realIndex })
          );
          
        }
      });
    } else if (type === AttachmentTaggingType.QUOTATION) {
      // Convert MPVendorDetailsId to VendorNumber
      const { MPVendorDetailsId, RFQNumber } = file.attachment;
      let initialSelectedVendorNumbers: string[] = [];
      const rfqData = this.rfqOutputService.rfqOutputData?.RFQ;
      if (MPVendorDetailsId && RFQNumber && rfqData) {

        for (const rfqItem of rfqData) {
          if (rfqItem.RFQNumber === RFQNumber && rfqItem.IsActive) {
            const foundVendorDetail = rfqItem.mpVendorDetails?.find(vendorDetail => vendorDetail.MPVendorDetailsId === MPVendorDetailsId)
            if (foundVendorDetail && foundVendorDetail.VendorNumber) {
              initialSelectedVendorNumbers = [foundVendorDetail.VendorNumber]
            }
          }
        }
      }

      // Open dialog
      let dialogRef = this.materialDialog.open(AttachmentTaggingComponent, {
        width: '950px',
        data: {
          type: type,
          MPDocumentNumber: this.form.documentNo,
          filename: file.attachment.FileName,
          selectedPurpose: file.selectedPurposeDropdowns?.find(
            (dropdown) => dropdown.id === file.selectedPurpose
          )?.value,
          initialSelectedVendorNumbers: initialSelectedVendorNumbers,
          initialSelectedRFQNumber: file.attachment.RFQNumber ?? '',
        },
      });

      dialogRef.afterClosed().subscribe((result: AttachmentTaggingResult) => {
        if (result) {
          let realIndex =
            this.paginator.pageIndex * this.paginator.pageSize + index;

          let fileCopy = structuredClone(file);
          const { selectedRFQNumber, selectedVendorNumbers } = result.form;

          // Convert VendorNumber to MPVendorDetailsId
          const selectedVendorNumber = selectedVendorNumbers?.[0];
          let selectedMPVendorDetailsId;
          const rfqData = this.rfqOutputService.rfqOutputData?.RFQ;
          if (selectedRFQNumber && selectedVendorNumber && rfqData) {
            for (const rfqItem of rfqData) {
              if (rfqItem.RFQNumber === selectedRFQNumber && rfqItem.IsActive) {
                const foundVendorDetail = rfqItem.mpVendorDetails?.find(
                  (vendorDetail) =>
                    vendorDetail.VendorNumber === selectedVendorNumber
                );
                if (foundVendorDetail) {
                  selectedMPVendorDetailsId =
                    foundVendorDetail.MPVendorDetailsId;
                }
              }
            }
          }

          
          fileCopy.attachment.AttachmentTypeId = Number(file.selectedPurpose);
          fileCopy.tableInformation.Purpose = file.selectedPurpose!;
          if(result.isSubmit) {
            fileCopy.attachment.RFQNumber = selectedRFQNumber
            ? selectedRFQNumber
            : undefined; // '' -> undefined
            fileCopy.attachment.MPVendorDetailsId = selectedMPVendorDetailsId;
          
            fileCopy.tableInformation.RFQNumber = selectedRFQNumber
              ? selectedRFQNumber
              : '-';
            fileCopy.tableInformation.RFQVendorTagged = selectedVendorNumber
              ? this.form.VendorsToSource.find(
                  (vendor) =>
                    !vendor.isDeleted &&
                    !vendor.Strikethrough &&
                    vendor.VendorNumber === selectedVendorNumber
                )?.Name ?? '-'
              : '-';
          }
         

          this.store.dispatch(
            updateAttachment({ file: fileCopy, index: realIndex })
          );
        }
      });
    }
  }

  dropped(files: NgxFileDropEntry[]) {
    this.showErrorMessage = false;
    this.files = files;
    for (const droppedFile of files) {
      // Is it a file?
      if (droppedFile.fileEntry.isFile) {
        const fileEntry = droppedFile.fileEntry as FileSystemFileEntry;
        fileEntry.file((file: File) => {
          this.processFile(file);
        });
      } else {
        // It was a directory (empty directories are added, otherwise only files)
        const fileEntry = droppedFile.fileEntry as FileSystemDirectoryEntry;
        console.log(
          'this is presumed directory: ',
          droppedFile.relativePath,
          fileEntry
        );
        // dont allow directories
        this.errorMsg = this.fileUploadErrorMsg;
        this.showErrorMessage = true;
      }
    }
  }

  browseFile(event: any) {
    const file: File = event.target.files[0];
    this.processFile(file);
  }

  async processFile(fileToProcess: File) {
    this.existingFile = undefined;
    try {
      // this.addSelectControls(fileToProcess.name);
      //dont allow more than 50mb.
      if (fileToProcess?.size > 50 * 1024 * 1024) {
        this._snackBar.open("Filesize cannot exceed 50MB", undefined, {
          verticalPosition: 'top',
          panelClass: 'app-notification-error',
          duration: 5000,
        });

        return;
      }
      
      if (!this.isValidFile(fileToProcess)) {
        this.showErrorMessage = true;
        this.errorMsg = this.fileUploadErrorMsg;
        this.bannerService.addMessage({ content: this.errorMsg, type: BannerType.error }, (Math.random() + 1).toString(36).substring(7))
        return;
      }
      let base64file = await this.convertToBase64(fileToProcess);
      const fileName = fileToProcess.name.split(/\.(?=[^\.]+$)/);
      const ext = fileName[fileName.length - 1];
      // let checkSpecialChars = this.restrictSpecialChars(fileName[0]);
      // if (checkSpecialChars) {
      //   this.showErrorMessage = true;
      //   this.errorMsg = this.fileNameErrorMsg;
      //   return;
      // }
      this.bannerService.clearValidationMessages()
      //populate table
      let fileUpload: AttachmentTableInformation = {
        FileId: this.fileUploadList.length + 1,
        FileName: fileToProcess.name,
        FileLink: base64file,
        Purpose: '0',
        TaggedItems: '-',
        RFQNumber: '-',
        RFQVendorTagged: '-',
        RFSVendorsTagged: '-',
        FileSize: (fileToProcess.size / 1024 / 1024).toFixed(2), //bytes to mb
        DateUploaded: new Date(),
        isPictureFile: false,
        Action: '',
        Strikethrough: false
      };
      //add to store
      let fileToStore: Attachment = {
        MPDocumentNumber: null,
        AttachmentId: null,
        FileName: fileToProcess.name,
        ExtensionName: ext,
        FileType: 'Supporting',
        FileSize: fileUpload.FileSize,
        TaggedItems: undefined,
        RFQNumber: undefined,
        MPVendorDetailsId: undefined,
        AttachmentTypeId: 0, //purpose id.
        Data: base64file,
        CreatedOn: new Date(),
        CreatedBy: this.loggedInUser.userName,
        ModifiedOn: new Date(),
        ModifiedBy: this.loggedInUser.userName,
        isDeleted: false,
        IsDuringPendingQuotations: null,
        IsDIRP:null,
        IsRestrictedITProductPolicy:null,
        Strikethrough: false
      };
      if (this.existingFile) {
        //if existing file is found to be uploaded earlier by the RO before the pending quotation stage, they should not be able to overwrite the existing file, so just modify the current file name and add file
        if (this.haveEditingRightsDuringPendingQuotation(undefined) && !this.haveEditingRightsDuringPendingQuotation(this.existingFile)) {
          this.renameFileAndAddToStore({
            attachment: fileToStore,
            tableInformation: fileUpload,
            fromDatabase: false,
          })
        }
        else
          return this.openDialog({
            attachment: fileToStore,
            tableInformation: fileUpload,
            fromDatabase: false,
          });
      } else {
        this.addFile({
          attachment: fileToStore,
          tableInformation: fileUpload,
          fromDatabase: false,
        });
        this.selectedPurpose.push('0');
      }
      this.wasAttachmentsAdded = true
    } catch (err) { }
  }

  renameFileAndAddToStore(fileToProcess: FileInformation) {
    const originalFileName = fileToProcess.attachment.FileName.split(/\.(?=[^\.]+$)/)[0]
    const regex = new RegExp(`${originalFileName}(?:\\(\\d+\\))?`, 'g');
    let finalList = this.fileUploadList.map(x => {
      const name = x.attachment.FileName.split(/\.(?=[^\.]+$)/)[0]
      const result = name.match(regex)
      return result
    }).filter(x => !!x)
    let count: number = finalList.length
    const newName = originalFileName +
      `(${count})` +
      '.' + fileToProcess.attachment.ExtensionName
    fileToProcess.attachment.ExtensionName,
      fileToProcess.attachment = {
        ...fileToProcess.attachment,
        FileName: newName,
      };
    fileToProcess.tableInformation = {
      ...fileToProcess.tableInformation,
      FileName: newName,
    };
    this.addFile(fileToProcess);
  }


  async uploadFile(fileToProcess: FileInformation) {
    if (this.dialogRef.componentInstance.getChoice()) {
      this.renameFileAndAddToStore(fileToProcess)
    } else {
      let indexToRemove = this.fileUploadList.findIndex(
        (file) => file.attachment.FileName == fileToProcess.attachment.FileName
      );
      this.removeFile(indexToRemove);
      this.addFile(fileToProcess);
    }
    this.dialogRef.close();
  }

  async downloadFile(record: FileInformation) {
    try {
      let data: any = await lastValueFrom(
        this.backendService.downloadAttachment(
          record.attachment.AttachmentId?.toString() as string
        )
      );
      const arrayBuffer: any = data.attachment.data;
      const int8Array = new Uint8Array(arrayBuffer);
      let blob = new Blob([int8Array], { type: `application/${record.attachment.ExtensionName}` });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = window.URL.createObjectURL(blob);
      a.download = record.attachment.FileName;
      a.click();
      window.URL.revokeObjectURL(a.href);
    } catch (e) {
      alert('error downloading');
    }
  }

  openDialog(file: FileInformation): void {
    this.dialogRef = this.dialog.open(InputDialogComponent, {
      // height: '350px',
      // width: '450px',
      hasBackdrop: true,
      data: {
        contentMsg: file.attachment.FileName,
        btnNameTwo: 'Upload',
        click: () => this.uploadFile(file),
        clickTwo: () => this.uploadFile(file),
      },
    });
  }

 

  

  getFileType(ext: string) {
    switch (ext.toLowerCase()) {
      case 'png':
        return 'image/png';
      case 'jpg':
        return 'image/jpg';
      case 'jpeg':
        return 'image/jpeg';
      case 'pdf':
        return 'application/pdf';
      case 'doc':
        return 'application/octet-stream';
      case 'docx':
        return 'application/octet-stream';
      default:
        return 'image/png';
    }
  }

  getViewableFileType(ext: string) {
    switch (ext.toLowerCase()) {
      case 'png':
        return true;
      case 'jpg':
        return true;
      case 'jpeg':
        return true;
      default:
        return false;
    }
  }

  restrictSpecialChars(fileName: string) {
    var specialChars = /[~#%*,{}\:<>?/+|&”]/;
    return specialChars.test(fileName);
  }

  private convertToBase64(file: File): Promise<any> {
    const reader = new FileReader();
    const future = new Promise((resolve, reject) => {
      reader.addEventListener(
        'load',
        function () {
          resolve(reader.result);
        },
        false
      );
      reader.addEventListener(
        'error',
        function (event) {
          reject(event);
        },
        false
      );

      reader.readAsDataURL(file);
    });
    return future;
  }

  isValidFile(file: File) {
    // if (file?.size >= (1024 * 70)) return false; //temp dont allow more than 70kb file for upload until payload increase

    const fileName = file?.name.split('.');
    // if (fileName.length !== 2) return false; what is this check?? dont remember..

    const ext = fileName[fileName.length - 1];
    const allowedExts = this.fileExtList;
    if (allowedExts.includes(ext.toLowerCase())) return false;
    let existingFile = this.fileUploadList.find((docs) => {
      return docs.attachment.FileName == file?.name && !docs.attachment.isDeleted && !docs.attachment.Strikethrough;
    })
    this.existingFile = existingFile;
    return true;
  }

  refresh() {
    this.cdr?.detectChanges();
    this.table?.renderRows();
  }

  getAttachments(): Attachment[] {
    return this.fileUploadList.map((file) => file.attachment);
  }

  dropdownValuesAllocator() {
    this.isCE = this.loggedInUser.userName === this.CE;
  }

  getFileUploadState(canUpdate: boolean): boolean {
    return !this.isReadOnly || (this.isCE && this.haveEditingRightsWhenTenderDC()) || this.isRFQ || this.haveEditingRightsDuringPendingQuotation(undefined) || this.haveEditingRightsWhenTenderDC() || canUpdate;
  }

  public get AttachmentTypeIdEnum(): typeof AttachmentTypeIdEnum {
    return AttachmentTypeIdEnum;
  }
}

export interface FileUpload {
  FileId: number;
  FileName: string;
  FileLink: string;
  Purpose: number;
  FileSize: string;
  DateUploaded: Date;
  isPictureFile: boolean;
  Action: string;
}

interface AttachmentTypeWholeList {
  RO: ExtendedAttachmentType[],
  CE: ExtendedAttachmentType[]
}
